import axios from "axios";

export const BASE =
  process.env.REACT_APP_API_URL ||
  "https://site--kf-backend-api--844vk4b7xzxp.code.run";

const apiInstance = axios.create({
  baseURL: BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

/* =====================================================
   CORE API WRAPPER
===================================================== */

/* =====================================================
   LOGIN SESSION HANDLING
   - The token is attached to EVERY request (this helper and
     any screen that uses plain axios).
   - If the server says the login is no longer valid (401),
     the user is logged out and sees the login page again.
===================================================== */

function handleExpiredLogin(error) {
  const status = error?.response?.status;
  const url = error?.config?.url || "";

  if (
    status === 401 &&
    !url.endsWith("/login") &&
    localStorage.getItem("kf_token")
  ) {
    localStorage.removeItem("kf_token");
    localStorage.removeItem("kf_user");
    window.location.reload();
  }

  return Promise.reject(error);
}

apiInstance.interceptors.response.use(r => r, handleExpiredLogin);
axios.interceptors.response.use(r => r, handleExpiredLogin);

const api = {
  setToken(token) {
    if (token) {
      apiInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete apiInstance.defaults.headers.common["Authorization"];
      delete axios.defaults.headers.common["Authorization"];
    }
  },

  get(path, params) {
    return apiInstance.get(path, { params });
  },

  post(path, data) {
    return apiInstance.post(path, data);
  },

  put(path, data) {
    return apiInstance.put(path, data);
  },
};

export { api };
export default api;

/* =====================================================
   EXISTING MODULES (UNCHANGED)
===================================================== */

export function postIncoming(data) {
  return apiInstance.post("/incoming", data);
}

export function postSales(data) {
  return apiInstance.post("/sales", data);
}

export function getOnlineOrders() {
  return api.get("/online-orders");
}

export function createBarcode(data) {
  return apiInstance.post("/barcode/create", data);
}
export function getIncomingBarcodeAvailability(incomingId) {
  return apiInstance.get(`/barcode/incoming/${incomingId}`);
}
export function importOnlineOrders(data) {
  return api.post(
    "/online-orders/import",
    data
  );
}